/* Walmea · page produit landing (wl-*) */
(function () {
  if (window.__wlInit) return;
  window.__wlInit = true;

  var swipe = function (el, fn) {
    if (!el) return;
    var x = null;
    el.addEventListener('touchstart', function (e) { x = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (x === null) return;
      var dx = e.changedTouches[0].clientX - x;
      x = null;
      if (Math.abs(dx) > 40) fn(dx < 0 ? 1 : -1);
    });
  };

  /* ---------- buy section ---------- */
  function initBuy(root) {
    var dataEl = root.querySelector('[data-wl-json]');
    if (!dataEl) return;
    var D = JSON.parse(dataEl.textContent);
    var state = { pack: D.defaultPack, units: [] };
    var first = D.variants.find(function (v) { return v.available; }) || D.variants[0];
    for (var i = 0; i < 10; i++) state.units.push(first.id);

    var money = function (cents) {
      var n = (cents / 100).toFixed(2);
      var withComma = n.replace('.', ',');
      var f = D.moneyFormat || '{{amount_with_comma_separator}} €';
      return f.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
        .replace(/\{\{\s*amount\s*\}\}/, n)
        .replace(/<[^>]+>/g, '');
    };
    var variant = function (id) { return D.variants.find(function (v) { return v.id === id; }); };
    var packTotals = function (p) {
      var full = 0;
      for (var u = 0; u < p.qty; u++) full += variant(state.units[u]).price;
      var total = p.price ? p.price : Math.round(full * (100 - p.pct) / 100);
      return { full: full, total: total };
    };

    /* gallery */
    var slides = root.querySelectorAll('.wl-gal__slide');
    var thumbs = root.querySelectorAll('.wl-thumb');
    var count = root.querySelector('.wl-gal__count');
    var cur = 0;
    var go = function (i) {
      if (!slides.length) return;
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === cur); });
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-on', k === cur);
        t.setAttribute('aria-current', k === cur ? 'true' : 'false');
      });
      if (count) count.textContent = (cur + 1) + ' / ' + slides.length;
    };
    var goMedia = function (mediaId) {
      if (!mediaId) return;
      slides.forEach(function (s, k) { if (String(s.dataset.mediaId) === String(mediaId)) go(k); });
    };
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var prev = root.querySelector('.wl-gal__arrow--prev');
    var next = root.querySelector('.wl-gal__arrow--next');
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    var main = root.querySelector('.wl-gal__main');
    if (main && slides.length > 1) swipe(main, function (d) { go(cur + d); });

    /* packs */
    var offerEls = function () { return document.querySelectorAll('[data-wl-pack]'); };
    var unitsBox = root.querySelector('[data-wl-units]');
    var priceEl = root.querySelector('[data-wl-price]');
    var wasEl = root.querySelector('[data-wl-was]');
    var offEl = root.querySelector('[data-wl-off]');
    var saveEl = root.querySelector('[data-wl-save]');
    var sbarInfo = document.querySelector('[data-wl-sbar-info]');
    var atcs = document.querySelectorAll('[data-wl-atc]');
    var live = root.querySelector('[data-wl-live]');
    var err = root.querySelector('[data-wl-err]');

    var renderUnits = function () {
      if (!unitsBox || D.hasOnlyDefault) return;
      var p = D.packs[state.pack];
      var html = '';
      for (var u = 0; u < p.qty; u++) {
        var v = variant(state.units[u]);
        html += '<div class="wl-unit"><div class="wl-unit__l">' + D.unitLabel + ' ' + (u + 1) + ' :<span>' + v.title + '</span></div>' +
          '<div class="wl-vrow" role="radiogroup" aria-label="' + D.unitLabel + ' ' + (u + 1) + '">';
        D.variants.forEach(function (o) {
          var on = o.id === v.id;
          html += '<button type="button" class="wl-vbtn' + (on ? ' is-on' : '') + '" role="radio" aria-checked="' + on + '"' +
            (o.available ? '' : ' disabled') + ' data-u="' + u + '" data-v="' + o.id + '">' + o.title + '</button>';
        });
        html += '</div></div>';
      }
      unitsBox.innerHTML = html;
    };
    if (unitsBox) {
      unitsBox.addEventListener('click', function (e) {
        var b = e.target.closest('.wl-vbtn');
        if (!b || b.disabled) return;
        state.units[+b.dataset.u] = +b.dataset.v;
        goMedia(variant(+b.dataset.v).media);
        update();
      });
    }

    var update = function () {
      var p = D.packs[state.pack];
      var t = packTotals(p);
      offerEls().forEach(function (el) {
        var on = +el.dataset.wlPack === state.pack;
        el.classList.toggle('is-on', on);
        el.setAttribute('aria-checked', on ? 'true' : 'false');
        var sel = el.querySelector('[data-wl-sel]');
        if (sel) sel.textContent = on ? D.selLabel : D.pickLabel;
        var pk = D.packs[+el.dataset.wlPack];
        if (!pk) return;
        var tt = packTotals(pk);
        var pe = el.querySelector('[data-wl-pp]');
        if (pe) pe.textContent = money(tt.total);
        var we = el.querySelector('[data-wl-pw]');
        if (we) { we.textContent = money(tt.full); we.hidden = tt.total >= tt.full; }
        var per = el.querySelector('[data-wl-per]');
        if (per) { per.textContent = money(Math.round(tt.total / pk.qty)) + ' ' + D.perLabel; per.hidden = pk.qty < 2; }
      });
      if (priceEl) priceEl.textContent = money(t.total);
      var disc = t.total < t.full;
      if (wasEl) { wasEl.textContent = money(t.full); wasEl.hidden = !disc; }
      if (offEl) { offEl.textContent = '−' + Math.round((1 - t.total / t.full) * 100) + ' %'; offEl.hidden = !disc; }
      if (saveEl) {
        saveEl.hidden = !disc;
        saveEl.textContent = D.saveLabel.replace('[montant]', money(t.full - t.total));
      }
      if (sbarInfo) sbarInfo.textContent = p.title + ' · ' + money(t.total);
      atcs.forEach(function (a) {
        if (a.classList.contains('is-done')) return;
        a.textContent = D.atcLabel;
      });
      renderUnits();
    };

    document.addEventListener('click', function (e) {
      var el = e.target.closest('[data-wl-pack]');
      if (!el) return;
      state.pack = +el.dataset.wlPack;
      update();
    });

    /* add to cart */
    var busy = false;
    var add = function () {
      if (busy) return;
      busy = true;
      if (err) err.hidden = true;
      var p = D.packs[state.pack];
      var map = {};
      for (var u = 0; u < p.qty; u++) map[state.units[u]] = (map[state.units[u]] || 0) + 1;
      var items = Object.keys(map).map(function (id) { return { id: +id, quantity: map[id] }; });
      var drawer = document.querySelector('cart-drawer');
      var body = { items: items };
      if (drawer && drawer.getSectionsToRender) {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      atcs.forEach(function (a) { a.disabled = true; });
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (res.status) throw new Error(res.description || res.message);
        if (live) live.textContent = D.addedLabel;
        atcs.forEach(function (a) { a.classList.add('is-done'); a.textContent = D.addedLabel; });
        setTimeout(function () {
          atcs.forEach(function (a) { a.classList.remove('is-done'); });
          update();
        }, 1800);
        if (drawer && drawer.renderContents && res.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents({ id: items[0].id, sections: res.sections });
        } else {
          window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
        }
      }).catch(function (e2) {
        if (err) { err.textContent = e2.message || D.errLabel; err.hidden = false; }
      }).finally(function () {
        busy = false;
        atcs.forEach(function (a) { a.disabled = false; });
      });
    };
    atcs.forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); add(); }); });
    var form = root.querySelector('[data-wl-form]');
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); add(); });

    /* sticky bar */
    var sbar = document.querySelector('[data-wl-sbar]');
    var mainAtc = root.querySelector('.wl-panel [data-wl-atc]');
    if (sbar && mainAtc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var e = en[0];
        sbar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(mainAtc);
    }

    update();
  }

  /* ---------- anatomy pins ---------- */
  function initAnat(root) {
    var pins = root.querySelectorAll('[data-wl-f]');
    var set = function (n) {
      pins.forEach(function (p) {
        var on = p.dataset.wlF === n;
        p.classList.toggle('is-on', on);
        p.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    };
    pins.forEach(function (p) { p.addEventListener('click', function () { set(p.dataset.wlF); }); });
  }

  /* ---------- reviews ---------- */
  function initRev(root) {
    var track = root.querySelector('.wl-rtrack');
    if (!track) return;
    var cards = track.children;
    var dots = root.querySelectorAll('.wl-dot');
    var prev = root.querySelector('[data-wl-rprev]');
    var next = root.querySelector('[data-wl-rnext]');
    var i = 0;
    var go = function (n) {
      i = Math.max(0, Math.min(cards.length - 1, n));
      track.style.transform = 'translateX(calc(' + (-i) + ' * (var(--cw) + 20px)))';
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); d.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === cards.length - 1;
    };
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    swipe(root.querySelector('.wl-rview'), function (d) { go(i + d); });
    go(0);
  }

  /* ---------- faq ---------- */
  function initFaq(root) {
    root.addEventListener('click', function (e) {
      var q = e.target.closest('.wl-acc__q');
      if (!q) return;
      var item = q.closest('.wl-acc__i');
      var open = !item.classList.contains('is-on');
      root.querySelectorAll('.wl-acc__i').forEach(function (it) {
        it.classList.remove('is-on');
        it.querySelector('.wl-acc__q').setAttribute('aria-expanded', 'false');
      });
      if (open) { item.classList.add('is-on'); q.setAttribute('aria-expanded', 'true'); }
    });
  }

  var boot = function (scope) {
    (scope || document).querySelectorAll('[data-wl-buy]').forEach(initBuy);
    (scope || document).querySelectorAll('[data-wl-anat]').forEach(initAnat);
    (scope || document).querySelectorAll('[data-wl-rev]').forEach(initRev);
    (scope || document).querySelectorAll('[data-wl-faq]').forEach(initFaq);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
